var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexSolo",class:_vm.size},[_c('div',{staticClass:"T1",style:({
    })},[(_vm.item.header)?_c('BoxCube',{style:({padding: '0'}),attrs:{"backgroundColor":'red',"item":_vm.item.header}}):_vm._e(),(_vm.item.hero)?_c('Hero',{attrs:{"item":_vm.item.hero}}):_vm._e(),_c('BoxCube',{style:([
        {padding: _vm.item.body.paddingAll || '20px'},
        _vm.item.footer ? {paddingBottom: '10px'} : {}
      ]),attrs:{"backgroundColor":'red',"item":_vm.item.body}}),(_vm.item.footer)?_c('BoxCube',{style:({padding: '10px'}),attrs:{"backgroundColor":'red',"item":_vm.item.footer}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }